// extracted by mini-css-extract-plugin
module.exports = {"base":"TopServiceCard_base__1yLMC","image":"TopServiceCard_image__1JgUy","countBadge":"TopServiceCard_countBadge__1gZ9P","title":"TopServiceCard_title__14BVM"};